// Allows interactions with window.location.search to be mocked in tests
export function getURLSearchParams() {
  return new URLSearchParams(window.location.search);
}